import * as React from 'react'
import { CSSProperties, FC } from 'react'
import { memory } from '../index'
import { TokenResponse } from '../../app/auth/type'
import { AUTHENTICATION_TOKEN } from '../../App.constants'
import qs from 'qs'
import { Nullable } from '../type'
import { Container } from './Container'
import { InputCard } from '../../app/inventory/component/InputCard'

export type StimulsoftViewerProps = {
  name: string
  request: Nullable<Record<string, any>>
  email?: {
    defaultEmailAddress?: string
    defaultEmailSubject?: string
    defaultEmailMessage?: string
  }
  skip?: boolean
  cartStyle?: CSSProperties
}
export const StimulsoftViewer: FC<StimulsoftViewerProps> = ({name, request, email, skip, cartStyle}) => {
  const token = memory.get<TokenResponse>(AUTHENTICATION_TOKEN)

  const resolveURL = () => {
    const stringify = qs.stringify({
      authorization: `${token?.token_type} ${token?.access_token}`,
      ...request ?? {},
      ...(email ?? {}),
    })

    const queryString = stringify ? `?${stringify}` : ''
    return `${process.env.REACT_APP_API_BASE_URL}/v1/report/view/${name}${queryString}`
  }

  return (
    <>
      {
        !skip &&
        <Container
          leftClassName='action-container'
          paddingClass='0'
        >
          <InputCard
            className='content-size'
            noBorder
            style={cartStyle}
          >
            <iframe
              title='Reports'
              src={resolveURL()}
              className='w-100'
              style={{height: 'calc(100vh - 10em)'}}
            />
          </InputCard>
        </Container>
      }
    </>
  )
}